const ProductList = () => import('Views/product/product-list');
const ProductDetail = () => import('Views/product/product-detail');
const ProductAddEdit = () => import('Views/product/product-addEdit');

export default[
  { path: '/product-list', component: ProductList },
  { path: '/product-detail/:id', component: ProductDetail },
  { path: '/product-add', component: ProductAddEdit },
  { path: '/product-edit/:id', component: ProductAddEdit },
];



// WEBPACK FOOTER //
// ./src/router/product.js